import { render, staticRenderFns } from "./ChargeContent.vue?vue&type=template&id=f8d81088&scoped=true&"
import script from "./ChargeContent.vue?vue&type=script&lang=js&"
export * from "./ChargeContent.vue?vue&type=script&lang=js&"
import style0 from "./ChargeContent.vue?vue&type=style&index=0&id=f8d81088&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d81088",
  null
  
)

export default component.exports